var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{
    'd-none':
      (_vm.item.displayOn && !_vm.display_none_check) ||
      (_vm.item.displayOn2 && !_vm.display_none_check2),
  }},[(!_vm.item.hideLabel)?_c('Label',{attrs:{"item":_vm.item}}):_vm._e(),_c('multiselect',{attrs:{"options":_vm.getOptions,"searchable":false,"close-on-select":true,"show-labels":false,"allow-empty":false,"placeholder":_vm.item.placeholder,"disabled":this.$route.params.categoryName == 'globalupdate'
        ? false
        : _vm.isGlobal
        ? true
        : false},model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}}),(_vm.submitted && _vm.validation.$error)?_c('div',{staticClass:"invalid-feedback"},[(!_vm.validation.required)?_c('span',[_vm._v("This value is required.")]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }